var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};

// src/event.ts
var event_exports = {};
__export(event_exports, {
  API: () => API,
  AP_MUSIC_THEORY_ASMT_ID: () => AP_MUSIC_THEORY_ASMT_ID,
  EVENT_TYPES: () => EVENT_TYPES,
  PROCTOR_EXPERIENCE_FLOW: () => PROCTOR_EXPERIENCE_FLOW
});
var AP_MUSIC_THEORY_ASMT_ID = "27";
var EVENT_TYPES = /* @__PURE__ */ ((EVENT_TYPES2) => {
  EVENT_TYPES2["INSCHOOL_AP"] = "inschool-ap";
  EVENT_TYPES2["INSCHOOL_APHYBRID"] = "inschool-aphybrid";
  EVENT_TYPES2["INSCHOOL_PSAT10"] = "inschool-psat10";
  EVENT_TYPES2["INSCHOOL_PSAT89"] = "inschool-psat89";
  EVENT_TYPES2["INSCHOOL_PSATNM"] = "inschool-psatnm";
  EVENT_TYPES2["INSCHOOL_SAT"] = "inschool-sat";
  EVENT_TYPES2["WEEKENDATSCHOOL_SAT"] = "weekend-at-school-sat";
  EVENT_TYPES2["WEEKEND_SAT"] = "wknd-sat";
  return EVENT_TYPES2;
})(EVENT_TYPES || {});
var API = /* @__PURE__ */ ((API2) => {
  API2["ADD_ROLE"] = "add-role";
  API2["ALORICA_SUBMIT"] = "alorica-submit";
  API2["RESUME_TESTING"] = "resume-testing";
  API2["DIGITAL_STUDENT_CHECK_IN"] = "digital-student-check-in";
  API2["DIGITAL_STUDENT_ROOM_SWITCH"] = "digital-student-room-switch";
  API2["ONBOARD"] = "onboard";
  API2["ROOM_JOIN_CODE_CREATED"] = "room-join-code-created";
  API2["ROOM_JOIN_CODE_DELETED"] = "room-join-code-deleted";
  return API2;
})(API || {});
var PROCTOR_EXPERIENCE_FLOW = /* @__PURE__ */ ((PROCTOR_EXPERIENCE_FLOW2) => {
  PROCTOR_EXPERIENCE_FLOW2["INSCHOOL_AP"] = "inschool-ap";
  PROCTOR_EXPERIENCE_FLOW2["INSCHOOL_APHYBRID"] = "inschool-aphybrid";
  PROCTOR_EXPERIENCE_FLOW2["INSCHOOL_PSAT10"] = "inschool-psat10";
  PROCTOR_EXPERIENCE_FLOW2["INSCHOOL_PSAT89"] = "inschool-psat89";
  PROCTOR_EXPERIENCE_FLOW2["INSCHOOL_PSATNM"] = "inschool-psatnm";
  PROCTOR_EXPERIENCE_FLOW2["INSCHOOL_SAT"] = "inschool-sat";
  PROCTOR_EXPERIENCE_FLOW2["N_A"] = "N/A";
  PROCTOR_EXPERIENCE_FLOW2["WEEKENDATSCHOOL_SAT"] = "weekend-at-school-sat";
  PROCTOR_EXPERIENCE_FLOW2["WEEKEND_SAT"] = "weekend-sat";
  return PROCTOR_EXPERIENCE_FLOW2;
})(PROCTOR_EXPERIENCE_FLOW || {});

// src/roles.ts
var roles_exports = {};
__export(roles_exports, {
  HONORARIA: () => HONORARIA,
  USER_ROLE_CODE: () => USER_ROLE_CODE
});
var HONORARIA = /* @__PURE__ */ ((HONORARIA2) => {
  HONORARIA2["UNASSIGNED_ROLE"] = "unassigned";
  return HONORARIA2;
})(HONORARIA || {});
var USER_ROLE_CODE = /* @__PURE__ */ ((USER_ROLE_CODE2) => {
  USER_ROLE_CODE2[USER_ROLE_CODE2["COORDINATOR"] = 800] = "COORDINATOR";
  USER_ROLE_CODE2[USER_ROLE_CODE2["PROCTOR"] = 801] = "PROCTOR";
  USER_ROLE_CODE2[USER_ROLE_CODE2["MONITOR"] = 802] = "MONITOR";
  USER_ROLE_CODE2[USER_ROLE_CODE2["CB_ADMIN"] = 803] = "CB_ADMIN";
  return USER_ROLE_CODE2;
})(USER_ROLE_CODE || {});

// src/codes.ts
var codes_exports = {};
__export(codes_exports, {
  AsmtSubtypeCd: () => AsmtSubtypeCd
});
var AsmtSubtypeCd = /* @__PURE__ */ ((AsmtSubtypeCd2) => {
  AsmtSubtypeCd2[AsmtSubtypeCd2["SAT_WITH_ESSAY"] = 1] = "SAT_WITH_ESSAY";
  AsmtSubtypeCd2[AsmtSubtypeCd2["SAT_WITHOUT_ESSAY"] = 2] = "SAT_WITHOUT_ESSAY";
  AsmtSubtypeCd2[AsmtSubtypeCd2["PSAT_10"] = 3] = "PSAT_10";
  AsmtSubtypeCd2[AsmtSubtypeCd2["PSAT_NMSQT"] = 4] = "PSAT_NMSQT";
  AsmtSubtypeCd2[AsmtSubtypeCd2["MATH_ONLY"] = 6] = "MATH_ONLY";
  AsmtSubtypeCd2[AsmtSubtypeCd2["NA"] = -2] = "NA";
  return AsmtSubtypeCd2;
})(AsmtSubtypeCd || {});

// src/contractManagement.ts
var FailedContractReasonCode = /* @__PURE__ */ ((FailedContractReasonCode2) => {
  FailedContractReasonCode2["NOT_AVAILABLE"] = "Not available in CB";
  FailedContractReasonCode2["INACTIVE"] = "Inactive CB account";
  return FailedContractReasonCode2;
})(FailedContractReasonCode || {});
export {
  codes_exports as CODES,
  event_exports as EVENT,
  FailedContractReasonCode,
  roles_exports as ROLES
};
